import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'core-js/modules/es6.array.fill.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import React__default, { useRef, useEffect } from 'react';
import { useSelect, useCombobox } from 'downshift';
import useCombinedRefs from '../../utils/use-combined-refs.js';
import { defaultItemSort, defaultItemFilter, useCommonStuff, DropdownButton, PortalMenu, ComplexItem } from './common.js';
import { SearchInput } from '../search-input/search-input.js';
import { Classes } from '@blueprintjs/core';
import { textPlaceholder } from '../theme/theme.js';

var _excluded = ["ref"],
    _excluded2 = ["label", "selectedItem", "onSelectedItemChange", "id"],
    _excluded3 = ["selectedItem", "onSelectedItemChange", "onSearchInputValueChange", "label", "id"],
    _excluded4 = ["ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultSelectItemSort = defaultItemSort;
var defaultSelectItemFilter = defaultItemFilter;

function SelectInternal(_ref) {
  var id = _ref.id,
      label = _ref.label,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? false : _ref$large,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? true : _ref$fill,
      disabled = _ref.disabled,
      minimal = _ref.minimal,
      intent = _ref.intent,
      selectedItem = _ref.selectedItem,
      placeholder = _ref.placeholder,
      getIcon = _ref.getIcon,
      getItemTooltip = _ref.getItemTooltip,
      _ref$multilineItems = _ref.multilineItems,
      multilineItems = _ref$multilineItems === void 0 ? true : _ref$multilineItems,
      hookResults = _ref.hookResults,
      commonStuffResults = _ref.commonStuffResults,
      searchInput = _ref.searchInput,
      _ref$isCombobox = _ref.isCombobox,
      isCombobox = _ref$isCombobox === void 0 ? false : _ref$isCombobox,
      _ref$showIconOnButton = _ref.showIconOnButton,
      showIconOnButton = _ref$showIconOnButton === void 0 ? true : _ref$showIconOnButton,
      _ref$showIconOnItem = _ref.showIconOnItem,
      showIconOnItem = _ref$showIconOnItem === void 0 ? true : _ref$showIconOnItem,
      dropdownButtonRef = _ref.dropdownButtonRef,
      _ref$autoWidthPopover = _ref.autoWidthPopover,
      autoWidthPopover = _ref$autoWidthPopover === void 0 ? true : _ref$autoWidthPopover;
  useEffect(function () {
    var _commonStuffResults$u;

    // need to trigger update to popper on select change because we are always showing
    // the menu. Also, update may be undefined so catch that case (types are incorrect).
    (_commonStuffResults$u = commonStuffResults.updatePopper) === null || _commonStuffResults$u === void 0 ? void 0 : _commonStuffResults$u.call(commonStuffResults);
  }, [selectedItem, commonStuffResults.updatePopper, commonStuffResults.referenceElement, hookResults.isOpen]);

  var _hookResults$getToggl = hookResults.getToggleButtonProps({
    id: id,
    "aria-label": label
  }),
      buttonRef = _hookResults$getToggl.ref,
      buttonProps = _objectWithoutProperties(_hookResults$getToggl, _excluded); // The dropdownButtonRef is for auto opening the select for cases like the inline
  // picklist cell edits in rowviewer


  var combinedButtonRef = useCombinedRefs(buttonRef, commonStuffResults.setReferenceElement, dropdownButtonRef);
  var selectedItemText = commonStuffResults.itemToString(selectedItem);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownButton, _extends({
    style: selectedItemText === placeholder ? {
      color: textPlaceholder,
      fontStyle: "italic"
    } : undefined,
    ref: combinedButtonRef
  }, buttonProps, {
    large: large,
    fill: fill,
    disabled: disabled,
    minimal: minimal,
    className: intent === "primary" ? Classes.INTENT_PRIMARY : intent === "success" ? Classes.INTENT_SUCCESS : intent === "warning" ? Classes.INTENT_WARNING : intent === "danger" ? Classes.INTENT_DANGER : undefined
  }, commonStuffResults.targetAriaProps, {
    "aria-label": "".concat(commonStuffResults.itemToString(selectedItem), ", ").concat(commonStuffResults.targetAriaProps["aria-label"]),
    "aria-expanded": hookResults.isOpen,
    tabIndex: 0,
    "data-test": id && "select-input-".concat(id),
    onKeyDown: function onKeyDown(e) {
      var _buttonProps$onKeyDow;

      if (isCombobox) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          hookResults.openMenu();
        }
      }

      (_buttonProps$onKeyDow = buttonProps.onKeyDown) === null || _buttonProps$onKeyDow === void 0 ? void 0 : _buttonProps$onKeyDow.call(buttonProps, e);
    },
    icon: getIcon && selectedItem && showIconOnButton ? getIcon(selectedItem) : undefined
  }), selectedItemText), /*#__PURE__*/React__default.createElement(PortalMenu, _extends({
    autoWidthPopover: autoWidthPopover,
    getMenuProps: commonStuffResults.getMenuPropsEnhancer(hookResults.getMenuProps),
    isOpen: hookResults.isOpen
  }, commonStuffResults.portalMenuProps, {
    searchInput: searchInput
  }), commonStuffResults.items.map(function (item, index) {
    var itemProps = hookResults.getItemProps({
      item: item,
      index: index
    });
    return /*#__PURE__*/React__default.createElement(ComplexItem, _extends({
      key: commonStuffResults.getItemId(item),
      getItemText: commonStuffResults.itemToString,
      placeholder: placeholder,
      getIcon: showIconOnItem ? getIcon : undefined,
      getItemTooltip: getItemTooltip,
      multilineItems: multilineItems
    }, itemProps, {
      item: item,
      index: index,
      highlightedIndex: hookResults.highlightedIndex,
      selected: selectedItem === item,
      "data-test": id && "select-option-".concat(id, "-").concat(index)
    }));
  })));
}

function SelectWithoutSearch(_ref2) {
  var label = _ref2.label,
      selectedItem = _ref2.selectedItem,
      _onSelectedItemChange = _ref2.onSelectedItemChange,
      id = _ref2.id,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var allCommonStuff = useCommonStuff(_objectSpread(_objectSpread({}, props), {}, {
    label: label
  }));
  var useSelectResults = useSelect(_objectSpread(_objectSpread({}, allCommonStuff.downshiftProps), {}, {
    selectedItem: selectedItem,
    onSelectedItemChange: function onSelectedItemChange(changes) {
      var _changes$selectedItem;

      return _onSelectedItemChange((_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 ? _changes$selectedItem : null);
    }
  }));
  return /*#__PURE__*/React__default.createElement(SelectInternal, _extends({}, props, {
    id: id,
    selectedItem: selectedItem,
    hookResults: useSelectResults,
    commonStuffResults: allCommonStuff
  }));
}

function SelectWithSearch(_ref3) {
  var selectedItem = _ref3.selectedItem,
      _onSelectedItemChange2 = _ref3.onSelectedItemChange,
      onSearchInputValueChange = _ref3.onSearchInputValueChange,
      label = _ref3.label,
      id = _ref3.id,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var allCommonStuff = useCommonStuff(_objectSpread(_objectSpread({}, props), {}, {
    label: label
  }));
  var inputElement = useRef(null);
  var useComboboxResults = useCombobox(_objectSpread(_objectSpread({}, allCommonStuff.downshiftProps), {}, {
    onSelectedItemChange: function onSelectedItemChange(changes) {
      var _changes$selectedItem2;

      return _onSelectedItemChange2((_changes$selectedItem2 = changes.selectedItem) !== null && _changes$selectedItem2 !== void 0 ? _changes$selectedItem2 : null);
    },
    onInputValueChange: function onInputValueChange(changes) {
      changes.inputValue !== undefined && onSearchInputValueChange(changes.inputValue);
    },
    selectedItem: selectedItem,
    stateReducer: function stateReducer(_state, action) {
      var changes = action.changes,
          type = action.type;

      switch (type) {
        case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            inputValue: _state.inputValue
          });

        case useCombobox.stateChangeTypes.ToggleButtonClick:
        case useCombobox.stateChangeTypes.FunctionSelectItem:
        case useCombobox.stateChangeTypes.FunctionOpenMenu:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
          return _objectSpread(_objectSpread({}, changes), {}, {
            inputValue: "" // clear input value

          });

        default:
          return changes;
      }
    },
    onIsOpenChange: function onIsOpenChange(changes) {
      var _allCommonStuff$downs, _allCommonStuff$downs2;

      if (changes.isOpen) {
        // slight delay because input is hidden until opened.
        setTimeout(function () {
          var _inputElement$current;

          return (_inputElement$current = inputElement.current) === null || _inputElement$current === void 0 ? void 0 : _inputElement$current.focus();
        }, 0);
      } else {
        setTimeout(function () {
          var _allCommonStuff$refer;

          return (_allCommonStuff$refer = allCommonStuff.referenceElement) === null || _allCommonStuff$refer === void 0 ? void 0 : _allCommonStuff$refer.focus();
        }, 0);
      }

      (_allCommonStuff$downs = (_allCommonStuff$downs2 = allCommonStuff.downshiftProps).onIsOpenChange) === null || _allCommonStuff$downs === void 0 ? void 0 : _allCommonStuff$downs.call(_allCommonStuff$downs2, changes);
    }
  }));

  var _useComboboxResults$g = useComboboxResults.getInputProps(),
      inputRef = _useComboboxResults$g.ref,
      inputProps = _objectWithoutProperties(_useComboboxResults$g, _excluded4);

  var combinedInputRef = useCombinedRefs(inputRef, inputElement);
  var containerProps = useComboboxResults.getComboboxProps();
  return /*#__PURE__*/React__default.createElement("div", containerProps, /*#__PURE__*/React__default.createElement(SelectInternal, _extends({}, props, {
    id: id,
    selectedItem: selectedItem,
    hookResults: useComboboxResults,
    commonStuffResults: allCommonStuff,
    searchInput: /*#__PURE__*/React__default.createElement(SearchInput, _extends({
      ref: combinedInputRef
    }, inputProps, {
      onClearValue: function onClearValue() {
        var _inputElement$current2;

        onSearchInputValueChange("");
        (_inputElement$current2 = inputElement.current) === null || _inputElement$current2 === void 0 ? void 0 : _inputElement$current2.focus();
      }
    }, allCommonStuff.targetAriaProps, {
      isLoading: !props.loadingPlaceholderItems && props.isLoading,
      disabled: props.loadingPlaceholderItems && props.isLoading
    })),
    isCombobox: true
  })));
}

function Select(props) {
  var typedProps = props; // this can be removed in typescript 4.5 for better inference.

  var onSearchInputValueChange = typedProps.onSearchInputValueChange;
  var searchInputValue = typedProps.searchInputValue;

  if (onSearchInputValueChange !== undefined && searchInputValue !== undefined) {
    return /*#__PURE__*/React__default.createElement(SelectWithSearch, _extends({}, props, {
      onSearchInputValueChange: onSearchInputValueChange,
      searchInputValue: searchInputValue
    }));
  }

  return /*#__PURE__*/React__default.createElement(SelectWithoutSearch, props);
}

export { Select, defaultSelectItemFilter, defaultSelectItemSort };
//# sourceMappingURL=select.js.map
